module.exports = __webpack_public_path__ + "files/nephrocare.267da8fdd23a0bd9f7b02ca6c2a7a3c5.pdf";